import {AbstractControl, ValidatorFn} from '@angular/forms';

export function intValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        return !/^-?\+?(0|[1-9]\d*)$/.test(control.value) ? {'int': {value: control.value}} : null;
    };
}


// WEBPACK FOOTER //
// /app/src/validators/int.validator.ts